"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Format = _interopRequireDefault(require("mf-parser/src/Format"));

var _parse = _interopRequireDefault(require("mf-parser/src/parse"));

var _toDisplay = _interopRequireDefault(require("mf-parser/src/util/toDisplay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const STYLE_SUPERIMPOSE = {
  flexDirection: 'column',
  display: 'inline-flex',
  justifyContent: 'center',
  textAlign: 'left',
  verticalAlign: 'middle'
};
const STYLE_SUPERIMPOSE_SUP_SUB = {
  lineHeight: 0.8,
  fontSize: '80%'
};

class MF extends _react.PureComponent {
  render() {
    const {
      mf,
      ...otherProps
    } = this.props;
    let parsed;

    try {
      parsed = (0, _parse.default)(mf);
    } catch (e) {
      // If not well formatted, just display the raw value.
      return /*#__PURE__*/_react.default.createElement("span", otherProps, mf);
    }

    let displayed = (0, _toDisplay.default)(parsed);
    return /*#__PURE__*/_react.default.createElement("span", otherProps, displayed.map(getComponent));
  }

}

exports.default = MF;
MF.propTypes = {
  /** Molecular formula */
  mf: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object
};

function getComponent(element, index) {
  switch (element.kind) {
    case _Format.default.SUBSCRIPT:
      {
        return /*#__PURE__*/_react.default.createElement("sub", {
          key: index
        }, element.value);
      }

    case _Format.default.SUPERSCRIPT:
      {
        return /*#__PURE__*/_react.default.createElement("sup", {
          key: index
        }, element.value);
      }

    case _Format.default.SUPERIMPOSE:
      {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: index,
          style: STYLE_SUPERIMPOSE
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: STYLE_SUPERIMPOSE_SUP_SUB
        }, element.over), /*#__PURE__*/_react.default.createElement("span", {
          style: STYLE_SUPERIMPOSE_SUP_SUB
        }, element.under));
      }

    default:
      return element.value;
  }
}